import React, { useState, useContext, useEffect, useMemo, useRef } from "react";
import { DetailsModal } from "../../../components/grid/DetailsModal";
import { Row, Col, Alert } from "react-bootstrap";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { MoneyCell } from "../../../components/grid/Kendo/CustomKendoGridCells";
import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import "./FeeAndAdjustmentDetailsModal.css";
import ErrorHandler from "../../../components/core/ErrorHandler";
import { UserContext } from "shared/context/UserContext";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

import { useFetchDetailsApiArguments } from "./hooks/useFetchDetailsApiArguments";
import { useInsertServerSideExport } from "shared/hooks/useInsertServerSideExport";
import {
  BuildFeeAndAdjustmentDetailRows,
  GetAdjustmentsByPayer,
} from "shared/helpers/FeeAndAdjustmentDetailsHelpers";
import { constants } from "./FeeAndAdjustmentResearchConstants";

import {
  DefaultColumnWidth,
  DefaultBooleanOrShortWidthColumnWidth,
  DefaultDateColumnWidth,
} from "../../../components/grid/Kendo/KendoGridAndColumnConstants";

export default function FeeAndAdjustmentDetailsModal(props) {
  const { submittedFormData, selectedFeeCodes, show, onClose } = props;
  let { mutate: mutateForServerSideExport } = useInsertServerSideExport();

  const userContext = useContext(UserContext);

  const clientGridRef = useRef();

  // const [allDetailsGridData, setAllDetailsGridData] = useState([]);
  const [adjustmentGridData, setAdjustmentGridData] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [showTooManyRowsMessage, setShowTooManyRowsMessage] = useState(false);
  // const [noGridAggregates, setNoGridAggregates] = useState([]);
  // const sendAggregatesToParent = (aggregatesFromSharedMain) => {
  //   setNoGridAggregates(aggregatesFromSharedMain.data);
  // };

  useEffect(() => {
    if (!show) {
      if (!IsNullOrEmpty(error)) setError({});

      if (!IsNullOrEmpty(adjustmentGridData)) setAdjustmentGridData([]);
    }
  }, [onClose]);

  useEffect(() => {
    setShowTooManyRowsMessage(false);
  }, [show]);

  // useEffect(() => {
  //   setError({});
  //   setAllDetailsGridData([]);
  //   setAdjustmentGridData([]);
  //   if (parameter.length != 0) {
  //     getReport();
  //   }
  // }, [parameter]);

  //console.log("FeeAndAdjustmentDetailsModal data", data);

  //add a function that does a calculation

  const { apiUrl, apiParams } = useFetchDetailsApiArguments(
    userContext.email,
    submittedFormData,
    selectedFeeCodes
  );

  //alert("apiUrl:" + apiUrl + " apiParams:" + JSON.stringify(apiParams));

  function setAdjustmentsData() {
    const gridData = clientGridRef.current
      ? clientGridRef.current.GetAllGridData()
      : null;

    //alert("setAdjustmentsData:" + JSON.stringify(gridData));

    if (gridData) {
      //alert("setAdjustmentGridData:" + JSON.stringify(orderedList));

      let adjustmentsData = getAdjustmentsByPayerData(gridData);

      setAdjustmentGridData(adjustmentsData);
    }
  }

  const getAdjustmentsByPayerData = (data) => GetAdjustmentsByPayer(data);

  const getAllDetailData = (data) => {
    // Rendering/processing a very large result on the browser's main thread makes the page
    // unresponsive, so a friendly message is shown instead of loading the rows.
    const { rows, exceedsLimit } = BuildFeeAndAdjustmentDetailRows(data);

    setShowTooManyRowsMessage(exceedsLimit);

    return rows;
  };

  function detailsGridErrorHandlerCallback(error) {
    let exportRequestParameters = { ...gridApiParams };

    let apiEndpoint = "api/FeeAndAdjustment/PostGetDetailsToAzureStorage";

    let mutateParameter = {
      error: error,
      endpoint: apiEndpoint,
      directParameters: exportRequestParameters
    };

    mutateForServerSideExport(mutateParameter);
  }

  const CustomMoneyCell = (props) => {
    var options = {
      removeNegativeSymbol: true,
    };

    return MoneyCell(props, options);
  };
  const gridApiParams = useMemo(() => {
    //If the modal is not showing then return an empty object
    if (!show) return {};

    //otherwise return the apiParams from the hook, all validations are done in the hook
    return apiParams;
  }, [show]);

  return (
    <DetailsModal
      title="Fee and Adjustment Research Detail"
      show={show}
      handleClose={onClose}
    >
      {/* <LoadingSpinner
        isDataLoading={isLoading}
        controlsName={"FeeAndAdjustmentDetailsModel"}
      /> */}
      <ErrorHandler
        error={error}
        onClose={() => {
          setError({});
        }}
      />
      {showTooManyRowsMessage && (
        <Alert
          variant="warning"
          dismissible
          onClose={() => setShowTooManyRowsMessage(false)}
        >
          {constants.detailsMessages.tooManyRows}
        </Alert>
      )}
      <div className="fee-and-adjustment-detail-summary-wrapper">
        <Row>
          <Col md={6} className="tight-grid multi-line-filter">
            {adjustmentGridData.length > 0 && (
              <Grid
                style={{
                  maxHeight: "10em",
                }}
                data={adjustmentGridData}
              >
                <GridColumn
                  key={"payer"}
                  field={"payer"}
                  title={"Payer"}
                //filter={"text"}
                />

                <GridColumn
                  key={"totalFeeAdjustmentAmountPerPayer"}
                  field={"totalFeeAdjustmentAmountPerPayer"}
                  title={"Adjustments"}
                  //filter={"numeric"}
                  cells={{
                    data: CustomMoneyCell,
                  }}
                />
              </Grid>
            )}
          </Col>
        </Row>
      </div>
      <div className="fee-and-adjustment-detail-summary-wrapper">
        <br />

        <Row>
          <Col md={12} className="tight-grid multi-line-filter">
            <SharedMainSelectableClientGrid
              ref={clientGridRef}
              apiGetEndpoint={apiUrl}
              apiParameters={gridApiParams}
              aggregateColumnSettings={null}
              onDataRetrievedProcessor={getAllDetailData}
              exportFileNamePrefix={"Fee&AdjustmentDetails"}
              gridErrorHandlerCallback={detailsGridErrorHandlerCallback}
              useQueryOptions={{ refetchOnWindowFocus: false }}
              onGridIsLoadingStatusChanged={(isLoading) => {
                if (!isLoading) {
                  setAdjustmentsData();
                }
              }}
            >
              <GridColumn
                field="payer"
                title="Payer"
                width={DefaultColumnWidth()}
              />
              <GridColumn
                field="checkNumber"
                title="Check Number"
                width={DefaultColumnWidth()}
              />
              <GridColumn
                key={"ncpdp"}
                field={"ncpdp"}
                title={"NCPDP"}
                filter={"text"}
                width={DefaultBooleanOrShortWidthColumnWidth()}
              />

              <GridColumn
                key={"checkDate"}
                field={"checkDate"}
                title={"Check Date"}
                filter={"date"}
                format="{0:d}"
                width={DefaultDateColumnWidth()}
              />

              <GridColumn
                key={"checkAmount"}
                field={"checkAmount"}
                title={"Check Amount"}
                filter={"numeric"}
                width={DefaultColumnWidth()}
                cells={{
                  data: CustomMoneyCell,
                }}
              />
              <GridColumn
                key={"rxNumber"}
                field={"rxNumber"}
                title={"Rx #"}
                filter={"text"}
                width={DefaultColumnWidth()}
              />
              <GridColumn
                key={"fillDate"}
                field={"fillDate"}
                title={"Fill Date"}
                filter={"date"}
                format="{0:d}"
                width={DefaultDateColumnWidth()}
              />
              <GridColumn
                key={"transactionDate"}
                field={"transactionDate"}
                title={"Transaction Date"}
                filter={"date"}
                format="{0:d}"
                width={DefaultDateColumnWidth()}
              />
              <GridColumn
                key={"patientName"}
                field={"patientName"}
                title={"Patient Name"}
                filter={"text"}
                width={DefaultColumnWidth()}
              />
              <GridColumn
                key={"tyCode"}
                field={"tyCode"}
                title={"TY Code"}
                filter={"text"}
                width={DefaultBooleanOrShortWidthColumnWidth()}
              />
              <GridColumn
                key={"feeAdjustmentAmount"}
                field={"feeAdjustmentAmount"}
                title={"Fee/Adjustment Amount"}
                filter={"numeric"}
                width={DefaultColumnWidth()}
                cells={{
                  data: CustomMoneyCell,
                }}
              />
              <GridColumn
                key={"reasonCode"}
                field={"reasonCode"}
                title={"Reason Code"}
                filter={"text"}
                width={DefaultColumnWidth()}
              />
              <GridColumn
                key={"reasonDescription"}
                field={"reasonDescription"}
                title={"Reason Description"}
                filter={"text"}
                width={DefaultColumnWidth()}
              />
            </SharedMainSelectableClientGrid>
          </Col>
        </Row>
      </div>
    </DetailsModal>
  );
}
